import React from 'react';
import styled from 'styled-components';

const Footer = () => {
    return (
        <StyledFooter>
            <div className="copyright">
                <p>nicolas d. &copy; 2025</p>
            </div>
            <div className="infos">
                <p>61 Boulevard Saint-Marcel, 75013 Paris</p>
                <p>Du mardi au samedi 10h-19h</p>
            </div>
            <div className="coordonnees">
                <p>salonnicolasd@gmail.com</p>
                <p>01.47.07.24.90</p>
            </div>
        </StyledFooter>
    )
}

const StyledFooter = styled.footer`
    min-height: 8vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 10rem;
    line-height: 2rem;
    background: white;
    position: sticky;
    bottom: 0;
    z-index: 5;
    color: rgb(30, 30, 30);
    p{
        font-size: 1rem;
    }
    .infos{
        text-align: center;
    }
    .coordonnees{
        text-align: right;
    }

    @media (max-width: 768px){
        display: none;
    }
`

export default Footer;